import { createAction } from "redux-actions";
import { apiGet, apiDelete, apiPost } from "../../api/index";
import {
  urlAccountSecured,
  urlExportAccountSecured,
  urlAccountManyDeleteSecured,
  urlAccountAllDeleteSecured,
} from "../../api/urls";
import { PAGE_SIZE_10 } from "../../constants/index";
import moment from "moment-timezone";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.company !== undefined) filter += "&company=" + filters.company;
    if (filters.year !== undefined) filter += "&year=" + filters.year;
    if (filters.period !== undefined) filter += "&period=" + filters.period;
    if (filters.date) {
      const date = moment(filters.date);
      filter += "&date=" + date.valueOf();
    }
  }
  if (sort) filter += "&sort=" + sort;
  return filter;
};

/**
 * Filter list orders.
 */
export const filterAccountAdm = createAction(
  "FILTER_ACCOUNT",
  (filter, param) =>
    apiGet(urlAccountSecured + generateFilterQuery(filter), param, true)(),
);

/**
 * Delete error.
 */
export const deleteAccountLink = createAction("DELETE_ACCOUNT", (param) =>
  apiDelete(urlAccountSecured, param, undefined)(),
);

/**
 * Delete many.
 */
export const deleteManyAccountLink = createAction(
  "DELETE_MANY_ACCOUNT",
  (obj) => apiPost(urlAccountManyDeleteSecured, obj, undefined, true)(),
);

/**
 * Filter list orders.
 */
export const listAccountToExport = createAction(
  "EXPORT_FILTER_ACCOUNT",
  (filter, param) =>
    apiGet(
      urlExportAccountSecured + generateFilterQuery(filter),
      param,
      true,
    )(),
);

export const deleteAll = createAction("DELETE_ALL", () =>
  apiDelete(urlAccountAllDeleteSecured, undefined, true)(),
);
